import { reactive } from 'vue'
import type {
  CommsError,
  CommsErrorComposable,
  CommsErrorResponse,
} from '@app/application/communication/types'

const castToArray = (errors: string | string[]): string[] => {
  if (Array.isArray(errors)) {
    return errors
  }

  return [errors]
}

function isCommsErrorResponse(e: CommsErrorResponse): e is CommsErrorResponse {
  const ce = e
  return ce?.body !== undefined && ce?.body?.errors !== undefined
}

export default function useCommsError(): CommsErrorComposable {
  const state = reactive<CommsError>({
    errors: {
      base: [],
      text: [],
    },
  })

  const handleErrors = (e: CommsErrorResponse): void => {
    if (isCommsErrorResponse(e)) {
      const { errors: bodyErrors } = e?.body || {}

      if (bodyErrors) {
        if (bodyErrors.text) {
          state.errors.text = castToArray(bodyErrors.text)
        }

        if (bodyErrors.base) {
          state.errors.base = castToArray(bodyErrors.base)
        }
      }

      return
    }
  }

  const hasErrors = (field: 'base' | 'text'): boolean => {
    const errorsForField = state.errors[field]

    return !!(errorsForField && errorsForField?.length > 0)
  }

  const clearTextErrors = (): void => {
    state.errors.text = []
  }

  return { errors: state, handleErrors, hasErrors, clearTextErrors }
}
